import React from 'react';
import PropTypes from 'prop-types';
import {
  BrowserRouter, Switch, Route, Redirect,
} from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import LoginPage from '../pages/LoginPage';
import LogoutPage from '../pages/LogoutPage';
import ForgotPasswordPage from '../pages/ForgotPasswordPage';
import { getProductBranding } from '../utils/branding';

function App({ branding }) {
  return (
    <ThemeProvider theme={getProductBranding(branding)}>
      <BrowserRouter>
        <Switch>
          <Route
            path="/login"
            render={props => <LoginPage {...props} branding={branding} />}
          />
          <Route path="/logout" component={LogoutPage} />
          <Route
            path="/forgot"
            render={props => <ForgotPasswordPage {...props} branding={branding} />}
          />
          <Redirect from="/" to="/login" />
        </Switch>
      </BrowserRouter>
    </ThemeProvider>
  );
}

App.propTypes = {
  branding: PropTypes.string.isRequired,
};

export default App;
